const obj = {
  id: '',
  plusId: '',
  miceId: '',
  active: false,
}

export default function PlusXMiceIdModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
